import { publicCallApi } from '../api'

const getAllCities = async () => {
  try {
    const response = await publicCallApi.getAllOffersCities()

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const cities = responseBody.data.map(({ id, attributes: city }) => ({
        value: city.ref || id,
        label: city.name || city.label || city.labelName,
      }))

      return {
        success: true,
        payload: { cities },
      }
    }
  } catch (error) {
    return {
      success: false,
      payload: { cities: [] },
      error: error?.message || 'Erro ao buscar cidades',
    }
  }

  return {
    success: false,
    payload: { cities: [] },
    error: 'Erro na resposta da API',
  }
}

const getSchools = async cityRef => {
  try {
    const response = await publicCallApi.getOffersSchools(cityRef)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const schools = responseBody.data.map(({ id, attributes: school }) => ({
        value: school.ref || id,
        label: school.name || school.label,
      }))

      return {
        success: true,
        payload: { schools },
      }
    }
  } catch (error) {
    return {
      success: false,
      payload: { schools: [] },
      error: error?.message || 'Erro ao buscar escolas',
    }
  }

  return {
    success: false,
    payload: { schools: [] },
    error: 'Erro na resposta da API',
  }
}

const getOffers = async (schoolRef, cityRef) => {
  try {
    const response = await publicCallApi.getOffers(schoolRef, cityRef)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      const offers = responseBody.data.map(({ id, attributes: offer }) => {
        const offerName =
          offer.label ||
          offer.curriculumName ||
          offer.curriculum_name ||
          offer.levelName ||
          offer.level_name ||
          `Oferta ${id}`

        return {
          id: parseInt(id),
          key: offer.key,
          cityRef: offer.cityRef || offer.city_ref,
          schoolRef: offer.schoolRef || offer.school_ref,
          degreeRef: offer.degreeRef || offer.degree_ref,
          shift: offer.shift,
          curriculumRef: offer.curriculumRef || offer.curriculum_ref,
          levelRef: offer.levelRef || offer.level_ref,
          total: offer.total,
          available: offer.available,
          consumed: offer.consumed,
          schoolName: offer.schoolName || offer.school_name,
          cityName: offer.cityName || offer.city_name,
          curriculumName: offer.curriculumName || offer.curriculum_name,
          levelName: offer.levelName || offer.level_name,
          shiftLabel: offer.shiftLabel || offer.shift_label,
          label: offerName,
        }
      })

      return {
        success: true,
        payload: { offers },
      }
    }
  } catch (error) {
    return {
      success: false,
      payload: { offers: [] },
      error: error?.message || 'Erro ao buscar ofertas',
    }
  }

  return {
    success: false,
    payload: { offers: [] },
    error: 'Erro na resposta da API',
  }
}

const getWaitingList = async offerId => {
  try {
    const response = await publicCallApi.getWaitingList(offerId)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      // A API retorna um objeto com table.waiting_lists que contém o array
      // Estrutura: { table: { waiting_lists: [{ table: { waiting_list: { aluno_nome, posicao } } }] } }
      const waitingListsArray =
        responseBody.table?.waiting_lists ||
        responseBody.waiting_lists ||
        (Array.isArray(responseBody) ? responseBody : responseBody.data || [])

      const waitingList = waitingListsArray.map((item, index) => {
        // Os dados estão em item.table.waiting_list
        const waitingListItem =
          item.table?.waiting_list ||
          item.waiting_list ||
          item.table ||
          item.attributes ||
          item

        return {
          id: waitingListItem.id || index,
          position: waitingListItem.position || index + 1,
          studentName: waitingListItem.aluno_nome || '--',
          situation: waitingListItem.situation || '--',
          legalPriorityGroupName:
            waitingListItem.legal_priority_group_name || '--',
        }
      })

      return {
        success: true,
        payload: { waitingList },
      }
    }
  } catch (error) {
    return {
      success: false,
      payload: { waitingList: [] },
      error: error?.message || 'Erro ao buscar fila de espera',
    }
  }

  return {
    success: false,
    payload: { waitingList: [] },
    error: 'Erro na resposta da API',
  }
}

const insertWaitingList = async data => {
  try {
    const response = await publicCallApi.insertWaitingList(data)

    const { ok, status } = response

    if (ok && (status === 200 || status === 201)) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: { response: responseBody },
      }
    }
  } catch (error) {
    return {
      success: false,
      payload: {},
      error: error?.message || 'Erro ao inserir na fila de espera',
    }
  }

  return {
    success: false,
    payload: {},
    error: 'Erro na resposta da API',
  }
}


const waitingListService = {
  getAllCities,
  getSchools,
  getOffers,
  getWaitingList,
  insertWaitingList
}

export default waitingListService
